import { useState, useEffect } from "react";
import { TaramLogo } from "../Icons";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";

import UserDropdown from "../UserDropdown";
import { useAppContext } from "../../context/AppContext";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  const { jwtToken } = useAppContext();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const links = [
    { label: "Why", href: "#why" },
    { label: "What", href: "#what-we-do" },
    { label: "How", href: "#how" },
    { label: "Industries", href: "#what" },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? "bg-background/95 backdrop-blur-md border-b border-border" : "bg-transparent"}`}
    >
      <div className="container flex items-center justify-between h-16">
        {/* <a href="#" className="flex items-center">
          <img src={taramLogo} alt="Taram" className="h-7" />
        </a> */}
        <Link to={"/"}>
          <TaramLogo className="w-[150px] h-[43px]" />
        </Link>

        <div className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors"
            >
              {l.label}
            </a>
          ))}

          {jwtToken ? (
            <UserDropdown />
          ) : (
            <>
              <Link
                to={"/login"}
                className="px-5 py-2 text-sm font-semibold rounded-lg border border-border text-foreground hover:bg-secondary transition-colors"
              >
                Login
              </Link>
              <Link
                to={"/signup"}
                className="px-5 py-2 text-sm font-semibold rounded-lg bg-primary text-primary-foreground hover:bg-primary/90 transition-colors"
              >
                Get Started
              </Link>
            </>
          )}
        </div>

        <button
          className="md:hidden text-foreground"
          onClick={() => setOpen(!open)}
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-background border-b border-border animate-fade-in">
          <div className="container py-4 flex flex-col gap-1">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="px-4 py-3 text-sm font-medium text-foreground hover:bg-secondary rounded-lg"
              >
                {l.label}
              </a>
            ))}

            {jwtToken ? (
              <UserDropdown />
            ) : (
              <>
                <Link
                  to={"/login"}
                  onClick={() => setOpen(false)}
                  className="mt-2 inline-flex items-center justify-center px-6 py-3 text-sm font-semibold rounded-lg border border-border text-foreground hover:bg-secondary"
                >
                  Login
                </Link>
                <Link
                  to={"/signup"}
                  onClick={() => setOpen(false)}
                  className="mt-2 inline-flex items-center justify-center px-6 py-3 text-sm font-semibold rounded-lg bg-primary text-primary-foreground"
                >
                  Get Started
                </Link>
              </>
            )}
          </div>
        </div>
      )}
    </nav>
  );
}
